// 描画コントロールパネル（地図左上に浮かぶ開閉式ツールバー）。
//
// 役割: 点/線/面の描画ツール切替、描画数の表示、レイヤー名入力、「レイヤー化」「クリア」を提供する。
//       描いた図形は「レイヤー化」で 1 つの新レイヤーとして取り込まれる（まとめてレイヤー化）。
//       既定は閉じた状態で、ヘッダーのボタンで開閉する。閉じるときは描画モードも解除して
//       地図操作に戻す（未確定の図形は保持し、再度開いてレイヤー化できる）。
// 関係: 状態（drawMode / featureCount / name）とロジックは App から props で受ける。表示と入力のみ。
//
// 注意: 既存レイヤーの頂点編集は行わない（plan.md §1.3）。本パネルは新規作図 → 新レイヤー生成のみ。
import { useState } from 'react'

const TOOLS = [
  { id: 'point', label: 'ポイント' },
  { id: 'line', label: 'ライン' },
  { id: 'polygon', label: 'ポリゴン' },
]

function DrawPanel({
  drawMode,
  featureCount,
  name,
  onNameChange,
  onSelectMode,
  onMaterialize,
  onClear,
}) {
  // 既定は閉じた状態。
  const [open, setOpen] = useState(false)

  // 閉じるときは描画モードを解除して地図操作に戻す（図形自体は保持）。
  const close = () => {
    onSelectMode('none')
    setOpen(false)
  }

  if (!open) {
    return (
      <button className="draw-toggle" onClick={() => setOpen(true)} title="描画ツールを開く">
        ✎ 描画{featureCount > 0 ? `（${featureCount}）` : ''}
      </button>
    )
  }

  return (
    <div className="draw-panel">
      <div className="draw-header">
        <h3>描画</h3>
        <button className="icon-btn" onClick={close} title="閉じる">
          ×
        </button>
      </div>
      <p className="field-help">ツールを選んで地図に描画。ライン/ポリゴンはダブルクリックで確定。</p>

      <div className="draw-tools">
        {TOOLS.map((t) => (
          <button
            key={t.id}
            className={`draw-tool${drawMode === t.id ? ' active' : ''}`}
            onClick={() => onSelectMode(drawMode === t.id ? 'none' : t.id)}
            aria-pressed={drawMode === t.id}
          >
            {t.label}
          </button>
        ))}
        <button
          className={`draw-tool${drawMode === 'none' ? ' active' : ''}`}
          onClick={() => onSelectMode('none')}
          title="描画を解除（地図操作に戻す）"
        >
          解除
        </button>
      </div>

      <p className="draw-count">描画数: {featureCount}</p>

      <label htmlFor="draw-name">レイヤー名</label>
      <input
        id="draw-name"
        type="text"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        placeholder="drawing_1"
      />

      <div className="draw-actions">
        <button className="primary" onClick={onMaterialize} disabled={featureCount === 0}>
          レイヤー化
        </button>
        <button onClick={onClear} disabled={featureCount === 0}>
          クリア
        </button>
      </div>
    </div>
  )
}

export default DrawPanel
